// Client-side image downscale + compress before upload.
// Phone photos can be 10-20MB which may hit proxy body-size limits / timeouts
// on the deployed ingress and appear to "hang at 0%". Shrinking them first
// makes uploads reliable and fast.
export async function compressImage(file, { maxDim = 1600, quality = 0.85 } = {}) {
  if (!file || !file.type || !file.type.startsWith("image/")) return file;
  try {
    const dataUrl = await new Promise((res, rej) => {
      const r = new FileReader();
      r.onload = () => res(r.result);
      r.onerror = rej;
      r.readAsDataURL(file);
    });
    const img = await new Promise((res, rej) => {
      const im = new Image();
      im.onload = () => res(im);
      im.onerror = rej;
      im.src = dataUrl;
    });
    const { width, height } = img;
    // Already small enough — skip re-encoding.
    if (Math.max(width, height) <= maxDim && file.size < 1_500_000) return file;
    const scale = Math.min(1, maxDim / Math.max(width, height));
    const w = Math.max(1, Math.round(width * scale));
    const h = Math.max(1, Math.round(height * scale));
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, w, h);
    const blob = await new Promise((res) => canvas.toBlob(res, "image/jpeg", quality));
    if (!blob) return file;
    const name = (file.name || "image").replace(/\.\w+$/, "") + ".jpg";
    return new File([blob], name, { type: "image/jpeg" });
  } catch {
    return file;
  }
}
